import { parseISO, format } from 'date-fns';

interface DealerReviewProps {
  id: number;
  title?: string;
  author?: string;
  content: string;
  overallRating: number;
  processRating?: number;
  serviceRating?: number;
  helpRating?: number;
  priceRating?: number;
  recommended?: boolean;
  writtenAt?: string;
}

export type DealerReview = DealerReviewProps;

function formatDate(date: string): string {
  return format(parseISO(date), 'MMMM d, yyyy');
}

export function createDealerReview(props: DealerReviewProps): DealerReview {
  const { writtenAt, ...otherProps } = props;
  return {
    ...otherProps,
    writtenAt: writtenAt ? formatDate(writtenAt) : writtenAt,
  };
}
